import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ApiService } from '@shared/services/api.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SnackService } from '@shared/services/snack.service';
import { ViewportService } from '@shared/services/viewport.service';
import { LocaleService } from '@shared/services/locale.service';
import { NumbersService } from '@shared/services/numbers.service';
import { AuthService } from '@shared/services/auth.service';

@Component({
	selector: 'app-user-verify',
	templateUrl: './user-verify.component.html',
	styleUrls: ['./user-verify.component.scss'],
})
export class UserVerifyComponent implements OnInit {
	constructor(
		private title: Title,
		private api: ApiService,
		private router: Router,
		private route: ActivatedRoute,
		private snack: SnackService,
		private numbers: NumbersService,
		public auth: AuthService,
		public viewport: ViewportService,
		public locale: LocaleService
	) {}

	loading: boolean = false;
	showResendOTP: boolean = false;
	showResendOTPTimer: number;
	autoSubmitForm: boolean = true;
	altPhone: string;
	type: string;

	form: UntypedFormGroup = new UntypedFormGroup({
		otp: new UntypedFormControl('', Validators.required),
	});

	//function to enter only digits
	isNumberKey(evt): boolean {
		let charCode = evt.which ? evt.which : evt.keyCode;

		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}

		return true;
	}

	setTimeoutResendOTP() {
		setTimeout(() => {
			this.showResendOTP = true;
		}, 60000);

		this.showResendOTPTimer = 60;

		let timer = setInterval(() => {
			this.showResendOTPTimer = this.showResendOTPTimer - 1;

			if (this.showResendOTPTimer === 0) {
				this.showResendOTP = true;
				this.showResendOTPTimer = undefined;
				clearInterval(timer);
			}
		}, 1000);
	}

	resendOTP() {
		this.showResendOTP = false;
		this.loading = true;

		const body: FormData = new FormData();
		body.append('lang', this.locale.lang);
		body.append('userID', this.auth.user()['userID']);
		body.append('type', this.type);

		if (this.altPhone) {
			body.append('altPhone', this.altPhone);
		}

		this.api.sendOTP(body).subscribe(
			(res) => {
				if (res['status'] === '1') {
					this.snack.open(this.locale.translations['user']['user-verify']['n239'], 10000);
					this.form.get('otp').reset('');
					this.setTimeoutResendOTP();
				} else {
					this.showResendOTP = true;
					this.snack.open(this.locale.translations['misc']['n174'], 10000);
				}

				this.loading = false;
			},
			(err) => {
				this.showResendOTP = true;
				this.snack.open(this.locale.translations['misc']['n174'], 10000);
				this.loading = false;
			}
		);
	}

	onKeyUp(field: string) {
		this.form.get(field).setValue(this.numbers.toNumeric(this.form.get(field).value.toString().replace(/\s/g, '')));

		if (this.form.valid && this.autoSubmitForm) {
			this.autoSubmitForm = false;
			this.onSubmit();
		}
	}

	onSubmit() {
		this.loading = true;

		const body: FormData = new FormData();
		body.append('lang', this.locale.lang);
		body.append('userID', this.auth.user()['userID']);
		body.append('otp', this.form['value']['otp']);
		body.append('type', this.type);

		this.api.validateOTP(body).subscribe(
			(res) => {
				if (res['status'] === '1') {
					this.auth.login(
						this.auth.user()['userID'],
						this.auth.user()['name'],
						this.altPhone ? this.altPhone : this.auth.user()['phone'],
						'1',
						this.auth.user()['token'],
						this.auth.user()['userType']
					);

					this.router.navigate([
						this.type === '1' ? '/user/' + this.auth.user()['userID'] + '/ads' : '/user/' + this.auth.user()['userID'] + '/profile',
					]);

					if (this.type === '1') {
						this.snack.open(this.locale.translations['user']['user-verify']['n237']);
					} else {
						this.snack.open(this.locale.translations['user']['user-profile']['s16']);
					}
				} else {
					this.snack.open(this.locale.translations['user']['user-verify']['n238'], 10000);
				}

				this.loading = false;
			},
			(err) => {
				this.snack.open(this.locale.translations['misc']['n174'], 10000);
				this.loading = false;
			}
		);
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['user']['user-verify']['n232'] + ' | ' + this.locale.translations['header']['n0']);
		this.setTimeoutResendOTP();

		this.route.queryParams.subscribe((queries: Params) => {
			this.altPhone = queries['altPhone'];
			this.type = queries['type'] === 'email' ? '2' : '1';
		});
	}
}
